<div class="container">
    <div class="w-100 text-end mt-3"
        *ngIf="serviceForm.value.services.length>0">
        <a class="cpr btn btn-primary"
            (click)="showSortModal(serviceForm.value.services, 'heading')">
            <i class="fa fa-sort" aria-hidden="true"></i> Change Position</a>
    </div>

    <form [formGroup]="serviceForm" (ngSubmit)="onSubmit(serviceForm)">
        <div class="row">
            <div class="col-md-4 mt-2" formArrayName="services"
                *ngFor="let item of service().controls; let i = index;">
                <div class="border shadow bg-white p-4 mt-2"
                    [formGroupName]="i">
                    <a *ngIf="service().controls.length>1"
                        href="javascript:void(0)" class="ms-2 close-btn"
                        (click)="removeservice(i)"><i
                            class="uil-times fa-2x"></i></a>
                    <div class="row">
                        <div class="mt-2  col-md-12">
                            <label class="col-form-label">Heading</label>
                            <input type="text" class="form-control"
                                placeholder="Heading" formControlName="heading"
                                (change)="dataChanged(i)"
                                [ngClass]="{'invalid': item.get('heading').invalid && isSubmitted}">
                        </div>
                        <div class="mt-2 col-md-12">
                            <label class="col-form-label">Description</label>
                            <ckeditor [editor]="Editor"
                                formControlName="description"
                                (change)="dataChanged(i)"
                                [ngClass]="{'invalid': item.get('description').invalid && isSubmitted}"
                                data="<p>Content of the editor.</p>"></ckeditor>

                            <!-- <textarea class="form-control" rows="3"
                                placeholder="Description"
                                formControlName="description"
                                (change)="dataChanged(i)"></textarea> -->
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-4 p-5">
                <div class="row">
                    <button class="btn btn-primary mt-1 me-1 col-md-12"
                        type="button" (click)="addservice()">
                        <i class="uil-plus"></i> Add
                    </button>

                    <button class="btn btn-info mt-1 col-md-12" type="submit">
                        <i class="bx bx-save"></i> Save All
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>